import React from 'react';
import { ServerIcon, HardDriveIcon, CalendarIcon, ClipboardCheckIcon, DatabaseIcon, AlertTriangleIcon, WifiIcon, ShieldIcon, CloudIcon, CodeIcon, TrendingUpIcon, TrendingDownIcon } from 'lucide-react';
interface KPICardsProps {
  activeFilter: string;
  activeCategory: string;
  activeStatus: string;
  activeClassification: string;
  dateRange: {
    start: string;
    end: string;
  };
}
export const KPICards: React.FC<KPICardsProps> = ({
  activeFilter,
  activeCategory,
  activeStatus,
  activeClassification,
  dateRange
}) => {
  const getFilteredData = () => {
    let totalAssets = 3452;
    let totalValue = '1.2T';
    let expiringAssets = 78;
    let validationNeeded = 42;
    if (activeFilter === 'pusat') {
      totalAssets = 587;
      totalValue = '450M';
      expiringAssets = 18;
      validationNeeded = 12;
    } else if (activeFilter === 'deputi') {
      totalAssets = 895;
      totalValue = '320M';
      expiringAssets = 24;
      validationNeeded = 10;
    } else if (activeFilter === 'stin') {
      totalAssets = 312;
      totalValue = '280M';
      expiringAssets = 15;
      validationNeeded = 8;
    } else if (activeFilter === 'binda') {
      totalAssets = 1250;
      totalValue = '450M';
      expiringAssets = 32;
      validationNeeded = 18;
    } else if (activeFilter === 'satker') {
      totalAssets = 408;
      totalValue = '150M';
      expiringAssets = 9;
      validationNeeded = 4;
    }
    if (activeCategory !== 'all') {
      totalAssets = Math.floor(totalAssets * 0.4);
      totalValue = (parseInt(totalValue) * 0.4).toFixed(0) + totalValue.slice(-1);
      expiringAssets = Math.floor(expiringAssets * 0.4);
      validationNeeded = Math.floor(validationNeeded * 0.4);
    }
    return {
      totalAssets,
      totalValue,
      expiringAssets,
      validationNeeded
    };
  };
  const data = getFilteredData();
  const getCategoryIcon = () => {
    switch (activeCategory) {
      case 'server':
        return <ServerIcon size={18} className="text-accent-info" data-id="element-525" />;
      case 'software':
        return <CodeIcon size={18} className="text-accent-green" data-id="element-526" />;
      case 'network':
        return <WifiIcon size={18} className="text-accent-info" data-id="element-527" />;
      case 'security':
        return <ShieldIcon size={18} className="text-accent-green" data-id="element-528" />;
      case 'digital':
        return <CloudIcon size={18} className="text-accent-info" data-id="element-529" />;
      default:
        return <HardDriveIcon size={18} className="text-accent-info" data-id="element-530" />;
    }
  };
  return <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden h-full flex flex-col" data-id="element-531">
      <div className="p-4 border-b border-gray-200 bg-gray-50/50" data-id="element-532">
        <h2 className="font-bold text-secondary flex items-center" data-id="element-533">
          <DatabaseIcon size={18} className="mr-2 text-primary" data-id="element-534" />
          KPI & Statistik
        </h2>
      </div>
      <div className="p-4 flex-1 overflow-y-auto" data-id="element-535">
        <div className="grid grid-cols-2 gap-3 mb-5" data-id="element-536">
          <div className="bg-gradient-to-br from-blue-50 to-white p-4 rounded-xl border border-blue-100" data-id="element-537">
            <div className="flex items-center space-x-2 mb-2" data-id="element-538">
              {getCategoryIcon()}
              <h3 className="text-[10px] font-semibold text-gray-500 uppercase tracking-wider" data-id="element-539">
                Total Aset
              </h3>
            </div>
            <div className="flex items-end justify-between" data-id="element-540">
              <p className="text-2xl font-bold text-secondary" data-id="element-541">
                {data.totalAssets.toLocaleString()}
              </p>
              <span className="text-xs text-green-600 font-medium flex items-center bg-green-50 px-2 py-0.5 rounded-full" data-id="element-542">
                <TrendingUpIcon size={12} className="mr-0.5" data-id="element-543" />
                +5%
              </span>
            </div>
          </div>
          <div className="bg-gradient-to-br from-green-50 to-white p-4 rounded-xl border border-green-100" data-id="element-544">
            <div className="flex items-center space-x-2 mb-2" data-id="element-545">
              <DatabaseIcon size={18} className="text-accent-green" data-id="element-546" />
              <h3 className="text-[10px] font-semibold text-gray-500 uppercase tracking-wider" data-id="element-547">
                Nilai Aset
              </h3>
            </div>
            <div className="flex items-end justify-between" data-id="element-548">
              <p className="text-2xl font-bold text-secondary" data-id="element-549">
                Rp {data.totalValue}
              </p>
              <span className="text-xs text-green-600 font-medium flex items-center bg-green-50 px-2 py-0.5 rounded-full" data-id="element-550">
                <TrendingUpIcon size={12} className="mr-0.5" data-id="element-551" />
                +3.2%
              </span>
            </div>
          </div>
          <div className="bg-gradient-to-br from-orange-50 to-white p-4 rounded-xl border border-orange-100" data-id="element-552">
            <div className="flex items-center space-x-2 mb-2" data-id="element-553">
              <CalendarIcon size={18} className="text-orange-500" data-id="element-554" />
              <h3 className="text-[10px] font-semibold text-gray-500 uppercase tracking-wider" data-id="element-555">
                Kontrak Habis
              </h3>
            </div>
            <div className="flex items-end justify-between" data-id="element-556">
              <p className="text-2xl font-bold text-orange-600" data-id="element-557">
                {data.expiringAssets}
              </p>
              <span className="text-xs text-orange-600 font-medium bg-orange-50 px-2 py-0.5 rounded-full" data-id="element-558">
                &lt;90 hari
              </span>
            </div>
          </div>
          <div className="bg-gradient-to-br from-purple-50 to-white p-4 rounded-xl border border-purple-100" data-id="element-559">
            <div className="flex items-center space-x-2 mb-2" data-id="element-560">
              <ClipboardCheckIcon size={18} className="text-purple-500" data-id="element-561" />
              <h3 className="text-[10px] font-semibold text-gray-500 uppercase tracking-wider" data-id="element-562">
                Perlu Validasi
              </h3>
            </div>
            <div className="flex items-end justify-between" data-id="element-563">
              <p className="text-2xl font-bold text-purple-600" data-id="element-564">
                {data.validationNeeded}
              </p>
              <span className="text-xs text-purple-600 font-medium bg-purple-50 px-2 py-0.5 rounded-full" data-id="element-565">
                Pending
              </span>
            </div>
          </div>
        </div>

        <div className="space-y-4" data-id="element-566">
          <div className="bg-gray-50 rounded-xl p-4 border border-gray-100" data-id="element-567">
            <h3 className="text-[10px] font-semibold text-gray-500 uppercase tracking-wider mb-3" data-id="element-568">
              Status Aset
            </h3>
            <div className="space-y-3" data-id="element-569">
              <div data-id="element-570">
                <div className="flex items-center justify-between mb-1.5" data-id="element-571">
                  <div className="flex items-center space-x-2" data-id="element-572">
                    <span className="w-2 h-2 bg-accent-green rounded-full" data-id="element-573"></span>
                    <span className="text-xs font-medium text-gray-700" data-id="element-574">
                      Aset Aktif
                    </span>
                  </div>
                  <span className="text-xs font-bold text-gray-700" data-id="element-575">72%</span>
                </div>
                <div className="h-2 w-full bg-gray-200 rounded-full overflow-hidden" data-id="element-576">
                  <div className="h-2 bg-gradient-to-r from-accent-green to-green-400 rounded-full transition-all duration-500" style={{
                  width: '72%'
                }} data-id="element-577"></div>
                </div>
              </div>
              <div data-id="element-578">
                <div className="flex items-center justify-between mb-1.5" data-id="element-579">
                  <div className="flex items-center space-x-2" data-id="element-580">
                    <span className="w-2 h-2 bg-orange-500 rounded-full" data-id="element-581"></span>
                    <span className="text-xs font-medium text-gray-700" data-id="element-582">
                      Kontrak Akan Habis
                    </span>
                  </div>
                  <span className="text-xs font-bold text-gray-700" data-id="element-583">
                    {Math.round(data.expiringAssets / data.totalAssets * 100)}
                    %
                  </span>
                </div>
                <div className="h-2 w-full bg-gray-200 rounded-full overflow-hidden" data-id="element-584">
                  <div className="h-2 bg-gradient-to-r from-orange-500 to-orange-400 rounded-full transition-all duration-500" style={{
                  width: `${data.expiringAssets / data.totalAssets * 100}%`
                }} data-id="element-585"></div>
                </div>
              </div>
              <div data-id="element-586">
                <div className="flex items-center justify-between mb-1.5" data-id="element-587">
                  <div className="flex items-center space-x-2" data-id="element-588">
                    <span className="w-2 h-2 bg-accent-red rounded-full" data-id="element-589"></span>
                    <span className="text-xs font-medium text-gray-700" data-id="element-590">
                      Aset Kritis
                    </span>
                  </div>
                  <span className="text-xs font-bold text-gray-700" data-id="element-591">4%</span>
                </div>
                <div className="h-2 w-full bg-gray-200 rounded-full overflow-hidden" data-id="element-592">
                  <div className="h-2 bg-gradient-to-r from-accent-red to-red-400 rounded-full transition-all duration-500" style={{
                  width: '4%'
                }} data-id="element-593"></div>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-gray-50 rounded-xl p-4 border border-gray-100" data-id="element-594">
            <h3 className="text-[10px] font-semibold text-gray-500 uppercase tracking-wider mb-3" data-id="element-595">
              Distribusi Kategori
            </h3>
            <div className="space-y-2.5" data-id="element-596">
              {[{
              name: 'Server & Komputasi',
              pct: 30,
              color: 'bg-blue-500'
            }, {
              name: 'Jaringan & Komunikasi',
              pct: 25,
              color: 'bg-green-500'
            }, {
              name: 'Software & Lisensi',
              pct: 20,
              color: 'bg-yellow-500'
            }, {
              name: 'Keamanan Siber',
              pct: 15,
              color: 'bg-purple-500'
            }, {
              name: 'Infrastruktur Digital',
              pct: 10,
              color: 'bg-pink-500'
            }].map(cat => <div key={cat.name} data-id="element-597">
                  <div className="flex items-center justify-between mb-1" data-id="element-598">
                    <span className="text-xs text-gray-600" data-id="element-599">{cat.name}</span>
                    <span className="text-xs font-semibold text-gray-700" data-id="element-600">
                      {cat.pct}%
                    </span>
                  </div>
                  <div className="h-1.5 w-full bg-gray-200 rounded-full overflow-hidden" data-id="element-601">
                    <div className={`h-1.5 ${cat.color} rounded-full transition-all duration-500`} style={{
                  width: `${cat.pct}%`
                }} data-id="element-602"></div>
                  </div>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </div>;
};